var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dragscroll",rawName:"v-dragscroll:nochilddrag",arg:"nochilddrag"}],staticClass:"rr-dragscroll-container"},[_c('router-view',{staticClass:"rr-app"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }